import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  CardActionArea,
  Grid,
  Container,
  Divider,
  Typography,
  TextField,
  IconButton,
  Alert,
  AlertTitle,
  CircularProgress,
  Paper,
  Tabs,
  Tab,
  CardActions,
  Button,
  Autocomplete
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup'; // eslint-disable-line
import moment from 'moment';
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import Api from '../../utils/api';
import Diversos from '../../utils/diversos';
import UsuarioForm from '../../components/Usuario/UsuarioForm';

require('moment/locale/pt-br.js'); // eslint-disable-line

const UsuarioEdit = (props) => {
  const history = useNavigate();
  const api = new Api();
  const diversos = new Diversos();
  const auth = useSelector((state) => state.auth);
  const { id } = useParams();
  const [hasError, setHasError] = useState(false);
  const [hasSuccess, setHasSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingReg, setIsLoadingReg] = useState(true);
  const [reg, setReg] = useState(null);
  const [aba, setAba] = useState(0);
  const [isLoadingMenu1, setIsLoadingMenu1] = useState(false);
  const [menu1, setMenu1] = useState([]);

  const get = async () => {
    setIsLoadingReg(true);

    try {
      const { data } = await api.get(`/users/${id}`, auth.token);

      setReg(data);
    } catch (e) {
      if (process.env.REACT_APP_ENVIROMENT !== 'development') {
        console.error(e);
      }
    } finally {
      setIsLoadingReg(false);
    }
  };

  const put = async (form, actions) => {
    if (!form.name || !form.email) {
      setHasError('Parâmetros obrigatórios inválidos');
      return false;
    }

    setHasError(null);
    setHasSuccess(null);
    setIsLoading(true);
    actions.setSubmitting(true);

    try {
      const param = {
        name: form.name,
        email: form.email,
        phone: form.phone || null,
        cpf: form.cpf || null,
        is_admin: form.is_admin || false
      };

      // Só envia password se foi informada
      if (form.password) {
        param.password = form.password;
      }

      const { data } = await api.put(`/users/${id}`, param, auth.token);

      setHasSuccess('Registro atualizado com sucesso.');

      await swal({
        title: 'Sucesso',
        text: `Usuário ${form.name} atualizado com sucesso!`,
        icon: 'success',
        dangerMode: false
      });

      window.history.back();
    } catch (e) {
      if (process.env.REACT_APP_ENVIROMENT !== 'development') {
        console.error(e);
      }

      setHasError(e.message);
    } finally {
      setIsLoading(false);
      actions.setSubmitting(false);
    }

    return true;
  };

  useEffect(async () => {
    await Promise.all([get()]);
  }, []);

  if (isLoadingReg) {
    return (
      <>
        <Helmet>
          <title>{`Usuário - Editar ${id} | ${process.env.REACT_APP_TITLE}`}</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 3
          }}
        >
          <Container maxWidth={false}>
            <Card>
              <CardHeader
                subheader="Usuário - Editar"
                title={`Usuário: ${id}`}
                avatar={
                  <IconButton size="small" color="primary" onClick={() => history(-1)}>
                    <ArrowBackIcon />
                  </IconButton>
                }
              />
              <Divider />
              <Box sx={{ p: 5 }}>
                <Typography align="center" variant="h5" color="primary">
                  <CircularProgress color="primary" sx={{ mb: 3 }} />
                  <br />
                  Buscando informações, por favor aguarde...
                </Typography>
              </Box>
            </Card>
          </Container>
        </Box>
      </>
    );
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...reg,
        password: ''
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().required('Nome é obrigatório'),
        email: Yup.string().email('E-mail inválido').required('E-mail é obrigatório'),
        password: Yup.string().min(6, 'Senha deve ter no mínimo 6 caracteres')
      })}
      onSubmit={put}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
        <UsuarioForm
          title={`Usuário - Editar ${id}`}
          subtitle={values.name}
          errors={errors}
          handleBlur={handleBlur}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          touched={touched}
          values={values}
          setFieldValue={setFieldValue}
          isLoading={isLoading}
          hasError={hasError}
          hasSuccess={hasSuccess}
        />
      )}
    </Formik>
  );
};

export default UsuarioEdit;
